export default Object.freeze({
  STRING: 'String',
  DATE: 'Date',
  INTEGER: 'int',
  BOOLEAN: 'Boolean',
  NUMBER: 'Number',
});
